import React from "react";

import "./styles.css";

const Header = () => <header id="main-header">Tibia Worlds</header>;

export default Header;
